import { createToggleProvider } from 'apprise-frontend-core/toggle/context'


// note: the solution is split with apprise-frontend-core, so that the base provider
// is available also to other frontend-only libraries that want to fullstack deps.

export const createToggles = <T extends string = string>(whitelist: () => T[]) => {

    const [Toggles, useBaseToggles] = createToggleProvider<T>()

    const useToggles = () => {

        const base = useBaseToggles()
        const enabled = whitelist()

        return {

            isFeatureEnabled: (toggle: T): boolean =>
                 enabled?.includes(toggle) || base.isFeatureEnabled(toggle)
        }
    }

    return [Toggles, useToggles] as const
}
